import React from "react";
import { Container, Stack, useMediaQuery, useTheme } from "@mui/material";
import { GreenPaper } from "../common";
import { AdminNav } from "./AdminNav";
import { ProtectedRoute } from "../../hooks";
import { ServiceNav } from "./ServiceNav";
import Header from "../../web/src/components/Header";
import Footer from "../../web/src/components/Footer";

export const AdminLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <ProtectedRoute>
      <div className="web-app-new-project-1234">
        <Header />
      </div>
      <Container
        maxWidth={!isMobile ? false : "xl"}
        sx={
          !isMobile
            ? {
                width: "95vw",
                px: 2,
                mx: "auto",
                marginTop: "200px",
              }
            : {}
        }
      >
        <div
          style={{
            backgroundColor: "#f7f7f7",
            padding: "10px 10px 10px 10px",
            border: "1px solid",
            borderRadius: "20px",
          }}
        >
          <Stack gap={2}>
            <AdminNav />
            <ServiceNav />
            {children}
          </Stack>
        </div>
      </Container>
      <div className="web-app-new-project-1234">
        <Footer />
      </div>
    </ProtectedRoute>
  );
};
